export default "__VITE_ASSET__CEGsHcnU__"